var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUiCrossCircleLtr = function SvgUiCrossCircleLtr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8 50C8 26.804 26.804 8 50 8s42 18.804 42 42-18.804 42-42 42S8 73.196 8 50m78.967 0c0-20.416-16.55-36.967-36.967-36.967S13.033 29.583 13.033 50 29.583 86.967 50 86.967 86.967 70.416 86.967 50",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.825 29.716 50 46.54 33.136 29.678a2.45 2.45 0 0 0-3.42.038l-.114.123c-.84.96-.801 2.421.114 3.336L46.54 50 29.678 66.864a2.45 2.45 0 0 0 .038 3.42l.123.114c.96.84 2.421.801 3.336-.114L50 53.459l16.864 16.863c.97.918 2.482.9 3.42-.038l.114-.123c.84-.96.801-2.421-.114-3.336L53.459 49.999l16.863-16.863a2.446 2.446 0 0 0-3.498-3.42"
  })));
};
export default SvgUiCrossCircleLtr;